import type { CaseDetail } from '../portfolio';

const jmilkDieteticCase: CaseDetail = {
  id: 'j-milk-dietetic',
  project: 'J-MILK x Dietetic Association',
  client: 'J-MILK',
  year: 'Archive',
  category: 'Experience / Retail / Event',
  role: 'Brand Experience / Retail / Event Design',
  issue: '牛乳の健康価値が、漠然とした印象に留まり、具体的な栄養価として伝わりにくかった。',
  challenge: '栄養の専門性を、生活者にわかりやすく、楽しく伝える体験を作ること。',
  insight: '「健康に良い」ではなく「毎日の習慣にできる」ことが、継続のきっかけになる。',
  strategy: '栄養学会との協働を活かし、科学的な信頼と親しみやすさを両立した体験を設計。',
  experience: '店頭・イベント・教育コンテンツを通じて、栄養価を楽しく伝える体験を構築。',
  output: 'Experience Design / Retail / Event / Education',
  impact: '牛乳の栄養価への理解と、日常的な摂取習慣の促進を実現。',
  images: [
    {
      src: '/assets/migrated/2de70e36faf9842adb06.webp',
      caption: '施策全体像 — タイアップ×イベントプロモーション施策への手法・店頭展開計画',
    },
    {
      src: '/assets/migrated/33c60f541dc916abdd1e.webp',
      caption: '【店舗実験】サミット成城店・向台町店 実施報告書 — 表紙・目次',
    },
    {
      src: '/assets/migrated/01d83185fb58bf268566.webp',
      caption: '実施詳細 — 成城店展開イメージ（売場レイアウト図＋栄養士相談会・店頭実写）',
    },
    {
      src: '/assets/migrated/a81460fc6b12589c3066.webp',
      caption: '施策全体概要・実施詳細 — 管理栄養士の活用方針と実験の方向性',
    },
    {
      src: '/assets/migrated/f5e49f07c35917754aaa.webp',
      caption: '第8回 2016年 宣伝会議 企画コンペティション 協賛企業賞 受賞 — J-MILK × 管理栄養士 店頭実験',
    },
    {
      src: '/assets/migrated/4b5466b49de7f7f1c058.webp',
      caption: '店頭プロモーション展開 — 栄養相談会告知ポスター・フロア告知シート・コーナー展開',
    },
    {
      src: '/assets/migrated/34cc6bb38648685d0ac4.webp',
      caption: '施策事例 — タイアップ×イベントプロモーション施策への手法（栄養士相談会ポスター・POP・店頭実写）',
    },
    {
      src: '/assets/migrated/c7b080212a902a0fddb0.webp',
      caption: 'サミット成城店・向台町店 実売場写真 — 牛乳乳製品売場のプロモーション展開',
    },
    {
      src: '/assets/migrated/506c950dfd90036160cc.webp',
      caption: '牛乳売場ディスプレイ — 健康バランスメニュー・新じゃがいも栄養POP・フロア展開',
    },
    {
      src: '/assets/migrated/063a1955f5eda15bc3e7.webp',
      caption: '牛乳売場ディスプレイ — 健康バランスメニュー・新じゃがいも栄養POP',
    },
    {
      src: '/assets/migrated/0cd34abae0908cdef8c4.webp',
      caption: '健康・食育ステーション — 六角形什器デザイン（W600）と実施写真',
    },
    {
      src: '/assets/migrated/bd3eb7e36935ebcef765.webp',
      caption: '当施策の企画フレーム — Jミルク×日本栄養士会×食品スーパー 流通連携モデル',
    },
    {
      src: '/assets/migrated/b74ca4ceb308474ffffc.webp',
      caption: '店頭実施写真 — 健康・食育ステーションとフロア誘導シール',
    },
    {
      src: '/assets/migrated/0bfb046fdcfe60b71a4e.webp',
      caption: '健康・食育ステーション実写 — 六角形什器＋フロア誘導シール（おさんぽスタート！）',
    },
  ],
};

export default jmilkDieteticCase;